import React from 'react';
import styles from './Membership.module.css';
import SubPageTop from '../components/SubPageTop';
import ScrollReveal from '../components/Ui/ScrollReveal';
import { FiMessageSquare, FiUserCheck, FiSettings, FiFileText } from "react-icons/fi";
const steps = [
    {
        icon: <FiMessageSquare size={32} color="#ff5670" />,
        title: "기업 색채 문의",
        desc: "멤버쉽 담당 및 한국 감성색채협회 문의",
    },
    {
        icon: <FiUserCheck size={32} color="#ff5670" />,
        title: "담당자 매칭 멤버쉽 체결",
        desc: "전문의뢰 내용 확인 후 담당자 배정 멤버쉽 체결 세금계산서 발행",
    },
    {
        icon: <FiSettings size={32} color="#ff5670" />,
        title: "전담 전문가 및 검수작업",
        desc: "각 전문가와 검수가 결성하여 프로젝트 수행",
    },
    {
        icon: <FiFileText size={32} color="#ff5670" />,
        title: "결과보고서",
        desc: "색채 검수 가이드 착출 인력 결과 보고",
    },
];

function Membership() {
    return (
        <div className={styles.membershipWrap}>
            <SubPageTop title="Member" />
            <div className={styles.content}>
                <ScrollReveal>
                    <div className={styles.section01}>
                    <div className={styles.imgbox}>
                        <img
                            src="/image/business-meeting-with-colleagues-at-office.png"
                            alt="컬러 이미지"
                        />
                    </div>
                    <div className={styles.infoBox}>
                        <div className={styles.infoHeader}>
                            <p className={styles.koTitle}>
                                기업 멤버쉽 제도
                            </p>
                        </div>
                        <div className={styles.infoDetail}>
                            <div className={styles.infoDesc}>
                                <span>
                                    감성색채기반으로  컨설팅, 교육, 브랜딩의 전문 컬러 인재양성하여
                                    양질의 서비스를 제공 및 자문합니다.
                                    <br />
                                    본 협회 소속된 컬러리스트, 퍼스널컬러 전문강사, 색채심리전문가, 브랜드 컬러,
                                    환경 색채전문가  자격을 취득한 전문강사분들이 전국적으로 활동 중입니다.
                                    <br />
                                    컬러컨설팅과 색채전문교육 강사분들을 연계하고 있습니다.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section02}>
                    <div className={styles.imgbox}>
                        <img
                            src="/image/membership-01.png"
                            alt="이미지"
                            className={styles.img01}
                        />
                        <img
                            src="/image/membership-02.png"
                            alt="이미지"
                            className={styles.img02}
                        />
                    </div>
                    <div className={styles.infoBox}>
                        <div className={styles.infoDetail}>
                            <div className={styles.infoDesc}>
                                <p className={styles.infoDescTitle}>기본 사항</p>
                                <span>
                                    기업 컬러 배색 검수(협회 인증 검수팀 진행 감성색채 1급 이상 <br />
                                    / 업계경력 10년 이상) 1개(베이직), 3항목(프리미엄) 선택 진행
                                </span>
                            </div>
                            <ul className={styles.infoList}>
                                <li className={styles.infoDescTitle}>
                                    <span>대상</span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>1.</span>
                                    <span>기업 그룹 컨설팅 (임직원 대상) 이미지 / 브랜딩 / 컬러마인드 코칭 컨설팅</span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>2.</span>
                                    <span>고객 컨설팅 (1 day) (소비자 대상) : 브랜드 고객 이벤트 행사</span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>3.</span>
                                    <span>
                                        HR 교육 (직원 대상) : 업무 효율을 위한 역량력 강화 교육
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>4.</span>
                                    <span>퍼스널 컨설팅 대상 : CEO / 임원</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section03}>
                    <div className={styles.tableWrap}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>가입비</th>
                                    <th>혜택</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>BASIC</td>
                                    <td>150만 원</td>
                                    <td>
                                        <p>년회원 세미나 30% 할인 / 필수  색채 인증 , 배색가이드 제공</p>
                                        <p className={styles.tableinfo}>
                                            1년 기업 지정  자문인력 배정 / 기업색채인증 기본 가입 제공
                                            <br />
                                            · 항목 중 1개 선택 제공
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>PREMIUME</td>
                                    <td>300만 원</td>
                                    <td>
                                        <p>년회원 세미나 30% 할인 / 필수  색채 인증 , 배색가이드 제공</p>
                                        <p className={styles.tableinfo}>
                                            1년 기업 지정  자문인력 배정 / 기업색채인증 기본 가입 제공
                                            <br />
                                            · 항목 중 3개 선택 제공
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section04}>
                    <div className={styles.imgbox}>
                        <img
                            src="/image/membership-section04-01.png"
                            alt="이미지"
                        />
                    </div>
                    <div className={styles.infoBox}>
                        <div className={styles.infoHeader}>
                            <p className={styles.engTitle}>
                                Interview Iwagemaking
                            </p>
                            <p className={styles.koTitle}>
                                멤버쉽 서비스 소개
                            </p>
                        </div>
                        <div className={styles.infoDetail}>
                            <div className={styles.infoDesc}>
                                <p className={styles.infoDescTitle}>기업 브랜딩 </p>
                                <span>
                                    · 기업에 맞는 브랜드 컬러 검수 기본 진행을 통한 컬러 가이드 제공(필수) <br />
                                    · 기업 브랜드에 맞는 CI, BI, 제품, 공간 이미지에 맞는 컬러 가이드 제공(선택)
                                </span>
                                <p className={styles.infoDescTitle}>교육 및 컨설팅(2H)</p>
                                <span>
                                    ·  색채 이미지분석, 내면분석 등 기업에 맞는 강사진 배치 <br />
                                    ·  기업 브랜드에 맞는 컨설팅 행사, 심리진단, 퍼스널 진단, 브랜드컬러진단 등
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section05}>
                    <h2 className={styles.title}>기업 세부 혜택 선택 사항</h2>
                    <div className={styles.line}></div>

                    <div className={styles.benefitCards}>
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>기업교육 (HRD) – 2H</div>
                            <ul className={styles.cardList}>
                                <li>이미지 브랜딩<br />(NPO 퍼스널 이미지 진단, 컨설팅)</li>
                                <li>내면 이미지 분석<br />(기업 담당 역량력 강화 교육)</li>
                                <li>컬러 마인드 코칭 과정<br />(기업 담당 역량력 강화 교육)</li>
                                <li>감성색채교육<br />(기업 담당 역량력 강화 교육)</li>
                            </ul>
                        </div>
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>기업 컨설팅 – 2H</div>
                            <ul className={styles.cardList}>
                                <li>이미지 컨설팅</li>
                                <li>심리 컨설팅</li>
                                <li>브랜드컬러 컨설팅</li>
                                <li>공간컬러컨설팅</li>
                                <li>(기업 요청 컨설팅 서비스)</li>
                            </ul>
                        </div>
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>배색 / 색채 분석</div>
                            <ul className={styles.cardList}>
                                <li>색채 분석</li>
                                <li>배색제안 가이드</li>
                                <li>배색 감리</li>
                                <li>(기업 제품 및 브랜드 컬러 적용)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                </ScrollReveal>

                <ScrollReveal>
                    <div className={styles.section06}>
                    <div className={styles.processSection}>
                        <h2 className={styles.title}>
                            멤버쉽 프로세스
                        </h2>
                        <div className={styles.line}></div>
                        <div className={styles.steps}>
                            {steps.map((step, i) => (
                                <React.Fragment key={i}>
                                    <div className={styles.step}>
                                        <div className={styles.iconWrap}>
                                            {step.icon}
                                        </div>
                                        <div className={styles.textWrap}>
                                            <div className={styles.stepTitle}>
                                                {step.title}
                                            </div>
                                            <div className={styles.stepDesc}>
                                                {step.desc}
                                            </div>
                                        </div>
                                    </div>
                                    {i < steps.length - 1 && (
                                        <div className={styles.arrowWrap}>
                                            <img
                                                src="/image/arrow_right.png"
                                                alt="arrow_right"
                                                className={styles.arrow}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                </ScrollReveal>
            </div>
        </div>
    );
}

export default Membership;

